import { getApiPayment } from "./getApiPayment";
import { getApiPaymentAccountType } from "./getApiPaymentAccountType";
import { getApiPaymentFederalAch } from "./getApiPaymentFederalAch";
import { getApiPaymentType } from "./getApiPaymentType";
import { postApiPayment } from "./postApiPayment";

export function paymentController() {
  return {
    getApiPayment,
    postApiPayment,
    getApiPaymentFederalAch,
    getApiPaymentType,
    getApiPaymentAccountType,
  };
}
